import { formatPrice } from '../../../../../shared/js/formatters'
import { post as jsonPost } from '../../../../../shared/js/json-fetch'
import useTimeout from '../../../../../shared/js/use-timeout'
import React from 'react'
import { useState } from 'react'
import type { FlashProps } from '../../../shared/Module'
import type { SyntheticEvent } from 'react'

interface LoyaltyFormProps {
  ceilingCents: number
  onChange: Function
  slices: number[][]
  url: string
  // This one is for testing purpose.  Post function is injected from json-fetch
  // module using default params
  post?: Function
}

const LoyaltyForm = ({
  ceilingCents,
  onChange,
  post = jsonPost,
  slices = [],
  url,
}: LoyaltyFormProps) => {
  const [loyaltyHidden, setLoyaltyHidden] = useState(true)
  const [flash, setFlash] = useState<FlashProps | null>(null)
  const [disabled, setDisabled] = useState(false)

  // Remove flash messages after 5 seconds
  useTimeout(() => setFlash(null), 5000)

  // Skip rendering when there is no slices/points to use
  if (ceilingCents <= 0 || slices.length === 0) {
    return null
  }

  // Slices contains every possible slices for current customer points in order
  // to manage ceilingCents changes (customer changing line items quantities,
  // applied discounts…)
  const filteredSlices = slices.filter(
    ([slicePoints, sliceCents]) => sliceCents <= ceilingCents
  )

  // Skip rendering if there is no matching slice
  if (filteredSlices.length === 0) {
    return null
  }

  const [bestPoints, bestCents] = filteredSlices[filteredSlices.length - 1]

  return (
    <dl className='accordion loyalties-accordion'>
      <dt
        aria-controls='disclosure-loyalties'
        aria-expanded={loyaltyHidden}
        onClick={toggleDiscount}
      >
        Points de fidélité
      </dt>
      <dd
        id='disclosure-loyalties'
        className='c-voucher__content'
        hidden={loyaltyHidden}
      >
        <p>
          Vous pouvez utiliser <strong>{formatPoints(bestPoints)}</strong>{' '}
          points de fidélité qui vous donnent accès à{' '}
          <strong>{formatPrice(bestCents)}</strong> de remise sur votre commande
        </p>
        <button
          className='lb-btn lb-btn-type-1'
          onClick={applyLoyalties}
          disabled={disabled}
        >
          Utiliser mes points
        </button>
      </dd>
      {flash && (
        <div className={`c-message c-message--${flash.kind}`}>
          {flash.message}
        </div>
      )}
    </dl>
  )

  // Request server then print applied loyalties
  // or error message when not applicatble
  async function applyLoyalties(event: SyntheticEvent) {
    event.preventDefault()
    setDisabled(true)
    const { data, flash } = await post(url, {
      loyalty_points_used: bestPoints,
    })
    setDisabled(false)
    if (flash) {
      setFlash(flash)
    }
    if (data) {
      onChange(data)
    }
  }

  function toggleDiscount() {
    setLoyaltyHidden(!loyaltyHidden)
  }
}

const pointsFormatter = new Intl.NumberFormat('fr-FR')

function formatPoints(points: number) {
  return pointsFormatter.format(points)
}

export default LoyaltyForm
